import { render } from "./IconBookOpen.vue?vue&type=template&id=0d3c2582"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBookOpen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d3c2582"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d3c2582', __exports__)) {
    api.reload('0d3c2582', __exports__)
  }
  
  module.hot.accept("./IconBookOpen.vue?vue&type=template&id=0d3c2582", () => {
    api.rerender('0d3c2582', render)
  })

}


export default __exports__